/* eslint-disable max-len */
/* eslint-disable dot-notation */
import { Observable } from 'rxjs';
import { Action } from 'redux-actions';
import api from '@src/api';

interface GetRefreshQRCodePayload {
  id: string;
  verifyCode: string;
}
export const getRefreshQRCode = (payload: GetRefreshQRCodePayload): Observable<Action> => (
	api.get(`punch-in-qr-codes/refresh_code/${payload.id}?page_verify_code=${payload.verifyCode}`)
);

interface GetIsRefreshQRCodeExistsPayload {
  id: string;
}

export const getIsRefreshQRCodeExists = (payload: GetIsRefreshQRCodeExistsPayload): Observable<Action> => (
	api.get(`punch-in-qr-codes/refresh_code/${payload.id}/exists`)
);
